import { createBrowserClient } from '@supabase/ssr';
import type { SupabaseClient } from '@supabase/supabase-js';
import type { Database } from './database.types';

export function createClient(): SupabaseClient<Database> {
  // Cross-app session: browser-side sign-ins (password flow) must stamp the
  // same apex cookie domain the server clients use, or the session is a
  // host-only cookie that never reaches the other *.savagestrategic.io apps.
  // NEXT_PUBLIC_ vars are inlined at build time; when the domain is unset
  // (local dev) behavior is unchanged.
  const domain = process.env.NEXT_PUBLIC_AUTH_COOKIE_DOMAIN;
  return createBrowserClient<Database>(
    process.env.NEXT_PUBLIC_SUPABASE_URL!,
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!,
    domain ? { cookieOptions: { domain } } : undefined
  );
}
